export const initDiseaseRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
      {
        path: "/manage/diseases",
        name: "disease",
        component: () => import("@/pages/manage/diseases/index.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
      {
        path: "/manage/diseases/:id",
        name: "disease-id",
        component: () => import("@/pages/manage/diseases/id.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
    ];
